import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule],
})
export class LoaderComponent {
  constructor(private readonly loaderService: LoaderService) {}
  get $loaderEvent() {
    return this.loaderService.loaderEvent;
  }
}
